import React from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import store from '../../store';
import { getEffectivePrice } from '../../utils/shared.utils';
import './store-item.scss';

interface ProductProps {
    product: any,
    basket: any,
    client: any,
}

interface ProductState {
    showBasketLine: boolean,
    basketCount: number,
    basketMsg: string
}

const mapStateToProps = (state: any, props: any) => {
    let basketCount = 0;
    if (state.basket && state.basket.quantityById && props && props.product) {
        if (state.basket.quantityById[props.product.id]) {
            basketCount = state.basket.quantityById[props.product.id];
        }
    }
    return {
        basket: state.basket,
        basketCount: basketCount,
        client: state.client,
    }
}

class StoreItem extends React.Component<ProductProps, ProductState> {
    constructor(props: any) {
        super(props);
        let basketCount = 0;

        if (this.props.basket && this.props.basket.quantityById) {
            if (this.props.basket.quantityById[this.props.product.id]) {
                basketCount = this.props.basket.quantityById[this.props.product.id];
            }
        }
        this.state = {
            showBasketLine: false,
            basketCount: basketCount,
            basketMsg: ""
        };
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.basketCount != null) {
            let state = { basketCount: nextProps.basketCount, showBasketLine: this.state.showBasketLine};
            if (nextProps.basketCount === 0) {
                state.showBasketLine = false;
            }
            this.setState(state);
        }
    }

    placeInBasket() {
        if (this.state.basketCount === 0) {
            store.dispatch({
                type: 'addToBasket',
                product: this.props.product,
                count: 1
            });
        }
    }

    render() {
        return (
            <div className={`product-detail-item ${this.state.basketCount > 0 ? "selected" : ""}`}>
                <div className="product-item" onClick={() => this.placeInBasket()}>
                    <img className="product-image" src={this.props.product.imageSmUrl}/>
                </div>
                <div className="text-center" onClick={() => this.placeInBasket()}>
                    <div className="product-title">{this.props.product.name}</div>
                </div>
                <div className="product-info">
                    {this.props.product.info}
                </div>
                {this.props.product.barCode ? <div className="barcode-line">{this.props.product.barCode}</div> : null}
                { this.props.product.warehouseCount === 0 ? <div className="warehouse-line">Үлдэгдэл байхгүй</div> : null }
                { (() => {
                    const p = this.props.product;
                    const isClubMember = this.props.client?.company?.clubMember;
                    const effectivePrice = getEffectivePrice(p, isClubMember);
                    const isSale = p.saleActive && p.salePrice > 0;
                    const showStrike = effectivePrice !== p.price;

                    let priceBlock;
                    if (showStrike && isClubMember && !isSale) {
                      priceBlock = (
                        <>
                          <div className='original-line'>
                            <span className='original-price'>
                              <div className='club-original-price'>
                                <NumberFormat displayType={"text"} value={p.price} suffix=' ₮' thousandSeparator={true} />
                              </div>
                            </span>
                            { p.size && p.unit ? <span className='unit-text'> / {p.size} {p.unit}</span> : null }
                          </div>
                          <div className='price-block discounted'>
                            <div className='price-type-label club'>CLUB PRICE</div>
                            <div className='effective-price'>
                              <NumberFormat displayType={"text"} value={effectivePrice} suffix=' ₮' thousandSeparator={true} />
                            </div>
                          </div>
                        </>
                      );
                    } else if (showStrike && isSale) {
                      priceBlock = (
                        <>
                          <div className="sale-line">
                            <span className="sale">Sale</span>
                          </div>
                          <div className="price-line">
                            <span className="price">
                              <NumberFormat displayType={'text'} value={effectivePrice} suffix="₮" thousandSeparator={true} />
                            </span>
                            <span className="price-per">
                              {(p.size > 0 && p.unit) ? `/ ${p.size} ${p.unit}` : ""}
                            </span>
                          </div>
                        </>
                      );
                    } else {
                      priceBlock = (
                        <>
                          { p.size && p.unit ? <div className='unit-only'>/ {p.size} {p.unit}</div> : null }
                          <div className='effective-price'>
                            <NumberFormat displayType={"text"} value={p.price} suffix=' ₮' thousandSeparator={true} />
                          </div>
                        </>
                      );
                    }
                    return priceBlock;
                })() }
            </div>
        );
    }
}

export default connect(mapStateToProps)(StoreItem);